import React from 'react'
import UsersBody from '../../../components/AdminDashboard/Users/UsersBody'
import SideNav from '../../../layouts/AdminDashboard/SideNav'

const Users = () => {
    return (
        <div className='flex justify-end mobile:justify-start mobile:w-screen mobile:flex-col min-h-screen w-full mobile:bg-[#E5E5E5]'>
            
            {/* Side nav */}
            <SideNav />

            {/* Users Body */}
            <UsersBody />

        </div>
    )
}

export default Users